import services from 'services/services';

// Import types
import type { PersonalDataType, AddressType } from 'types/api/subscriber';
import type { InvoiceInfoType } from 'types/api/invoice';

export const initialAddress = {
	street: '',
	building_no: '',
	apartment_no: '',
	city: '',
	postal_code: ''
};

export const fetchSubscriberPersonalData = async (): Promise<PersonalDataType | null> => {
	try {
		const response = await services.get<PersonalDataType>('/subscriber/profile/get/personalData');
		return response.data;
	} catch {
		return null;
	}
};

export const updateSubscriberPersonalData = async (data: any) => await services.put('/subscriber/profile/update/personalData', data);

export const fetchSubscriberAddress = async (): Promise<AddressType | null> => {
	try {
		const response = await services.get<AddressType | ''>('/subscriber/address/get');
		return response.data || initialAddress;
	} catch {
		return null;
	}
};

export const updateSubscriberAddress = async (data: any) => await services.post('/subscriber/address/update', data);

export const fetchSubscriberInvoiceInfo = async () => services.get<InvoiceInfoType>('/invoice/info');

export const fetchSubscriberProductsUuids = async (isAuth = true) => {
	if (!isAuth) return [];

	try {
		const response = await services.get<{ data: string[] }>('/subscriber/products/uuids');
		return response.data.data;
	} catch (err) {
		return [];
	}
};
